import { render } from "./HighlightText.vue?vue&type=template&id=75f93aa6"
import script from "./HighlightText.vue?vue&type=script&lang=js"
export * from "./HighlightText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__